import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Contact from "../views/Contact.vue";
import Hebergements from "../views/Hebergements.vue";
import HebergementItem from "../views/HebergementItem.vue";
import TarifsResa from "../views/TarifsResa.vue";
import Actus from "../views/Actus.vue";
import ActuItem from "../views/ActuItem.vue";
import Epicerie from "../views/Epicerie.vue";
import VotreSejour from "../views/VotreSejour.vue";
import Aerodrome from "../views/Aerodrome.vue";
import ReservationStudio from "../views/reservation-studio.vue";
import ReservationGite from "../views/reservation-gite.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
  {
    path: "/nos-hebergements",
    name: "Hebergements",
    component: Hebergements,
  },
  {
    path: "/nos-hebergements/:type",
    name: "HebergementItem",
    component: HebergementItem,
  },
  {
    path: "/tarifs-et-reservation",
    name: "TarifsResa",
    component: TarifsResa,
  },
  {
    path: "/actualites",
    name: "Actus",
    component: Actus,
  },
  {
    path: "/actualites/:id",
    name: "ActuItem",
    component: ActuItem,
  },
  {
    path: "/epicerie",
    name: "Epicerie",
    component: Epicerie,
  },
  {
    path: "/votre-sejour",
    name: "VotreSejour",
    component: VotreSejour,
  },
  {
    path: "/aerodrome",
    name: "Aerodrome",
    component: Aerodrome,
  },
  {
    path: "/reservations-studio",
    name: "reservationsStudio",
    component: ReservationStudio,
  },
  {
    path: "/reservations-gite",
    name: "reservationsGite",
    component: ReservationGite,
  },

  { path: "*", name: "wrong", component: Home },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

export default router;
